import { ASSIGNMENT21 } from '../../assignments/assignments.data';

const UNIT3_DAY4 = {
    id: 21,
    unit: 'unit3', 
    route: '/units/unit3/day21',
    month: 'November',
    day: 5, 
    name: 'throwing shade',
    description: "Today we'll continue our WEBGL explorations by looking at materials, lighting and...shaders.  Shaders are a bit daunting, written in a variant of C called shader language, as they are.  But, tapping into the power of shaders lets us render images a LOT faster, with more resolution, detail and speed.  We'll look at the basics of working with shaders today.",
    illustrationURL:'https://res.cloudinary.com/chris-kubick/image/upload/v1604102337/side-effects/light-shade-ripples-pattern-swimming-pool-turquoise-clean-water-vivid-separatio-lines-separation-113595482_agwgav.jpg',
    assignmentRoute: '/units/unit3/day21/assignment', 
    assignment: ASSIGNMENT21,
  
    inspirationLinks: [
        {
            linkText: 'nothing is more fun than a hypercube full of monkeys',
            linkSrc: 'https://blogs.scientificamerican.com/roots-of-unity/nothing-is-more-fun-than-a-hypercube-of-monkeys/',
        },
        {
            linkText: 'stereophonic projection with henry segerman',
            linkSrc: 'https://artthescience.com/blog/2016/11/11/creators-henry-segerman/',
        },
        {
            linkText: 'the pure metal asteroid, Psyche',
            linkSrc: 'https://observer.com/2020/10/nasa-discover-asteroid-pysche-metal-10-quadrillion/',
        },
        {
            linkText: 'Andrew ferris web site',
            linkSrc: 'https://amf.fyi/',
        },
        {
            linkText: 'animate 10,000 points with shaders',
            linkSrc: 'https://bl.ocks.org/pbeshai/66f1a837ec33f787dace43e1b5039e31',
        },
        {
            linkText: 'shadertoy website',
            linkSrc: 'https://www.shadertoy.com/',
        },
        {
            linkText: 'how to port a shadertoy example to p5.js',
            linkSrc: 'https://itp-xstory.github.io/p5js-shaders/#/./docs/examples/shadertoy',
        },
        {
            linkText: 'Audio-based Image Distortion Effects with WebGL',
            linkSrc: 'https://tympanus.net/codrops/2020/02/24/audio-based-image-distortion-effects-with-webgl/',
        },
        {
            linkText: 'Fast and easy high resolution fractals with a pixel shader',
            linkSrc: 'http://nuclear.mutantstargoat.com/articles/sdr_fract/',
        },
        {
            linkText: '',
            linkSrc: '',
        },
        {
            linkText: '',
            linkSrc: '',
        },
        {
            linkText: 'the book of shaders',
            linkSrc: 'https://thebookofshaders.com/00/',
        },
        ],
        techLinks: [
  
            {
                linkText: 'coding train: light and material in webGl',
                linkSrc: 'https://www.youtube.com/watch?v=k2FguXvqp60&list=PLRqwX-V7Uu6bPhi8sS1hHJ77n3zRO9FR_&index=3',
            },
            {
                linkText: "'normal' (rainbow) cat in p5",
                linkSrc: 'https://editor.p5js.org/socalledsound/sketches/AhBNTJ83H',
            },

            {
                linkText: 'clouds on a cat',
                linkSrc: 'https://editor.p5js.org/socalledsound/sketches/dan9XWo2o',
            },
            {
                linkText: 'fox with colors',
                linkSrc: 'https://editor.p5js.org/socalledsound/sketches/ZD2Xorhfh',
            },


            {
                linkText: 'pixelate camera input using a shader',
                linkSrc: 'https://editor.p5js.org/socalledsound/sketches/-wnTyH5Dz',
            },


            {
                linkText: 'pixel mosaic shadera cam',
                linkSrc: 'https://editor.p5js.org/socalledsound/sketches/kVWQKkuNt',
            },
            {
                linkText: 'gradient shader on a sphere',
                linkSrc: 'https://editor.p5js.org/socalledsound/sketches/8XlSP85TX',
            },
            {
                linkText: "fly's eye mosaic on a fox",
                linkSrc: 'https://editor.p5js.org/socalledsound/sketches/rD7vvfHUX',
            },
            {
                linkText: 'sound ripple image shader',
                linkSrc: 'https://editor.p5js.org/socalledsound/sketches/k5Ib2t5Qa',
            },
        ], 
        videos: [

            {
    
            },
            {
    
            },
            {
    
            },
            {
    
            },
        ],   
}
export default UNIT3_DAY4